import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { ApiRecipientConstants } from "../../../../constants/api-constants/api-recipient.constants";
import { ApiLookupConstants } from "../../../../constants/api-constants/api-lookup.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { ApiUserSettingsConstants } from "../../../../constants/api-constants/api-user-settings.constants";
import { ApiRecipientVerificationConstants } from "../../../../constants/api-constants/api-recipient-verification.constants";
export let RecipientService = class RecipientService {
    appControllerService;
    http;
    clearRecipientEvent = new EventEmitter();
    constructor(appControllerService, http) {
        this.appControllerService = appControllerService;
        this.http = http;
    }
    getRecipientsObservable(params) {
        return this.http.get(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_PORTAL_RECIPIENT}`, { params }).pipe(map((recipients) => {
            return recipients.value;
        }));
    }
    getRecipientsByGroup(params) {
        return this.http.post(`${ApiRecipientConstants.URL}/${ApiRecipientConstants.FUNCTION_GET_PORTAL_RECIPIENTS_BY_GROUP}`, params);
    }
    getRecipientGroupsLookupObservable(moduleId) {
        const params = {
            $filter: `name eq 'RecipientGroup' and moduleId eq ${moduleId} and deleted eq false`,
            $orderBy: "name"
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params }).pipe(map((lookups) => {
            return lookups.value;
        }));
    }
    checkStepMetaRecipientGroups(stepMetaGroups) {
        return stepMetaGroups.length > 0 ? RecipientUtils.mapStepMetaRecipientGroups(stepMetaGroups) : [];
    }
    clearRecipientTrigger(isCleared) {
        this.clearRecipientEvent.emit(isCleared);
    }
    listenToClearRecipient() {
        return this.clearRecipientEvent;
    }
    getApplicantDataFromUserSettings(userId, key) {
        const params = {
            $filter: `userId eq ${userId} and key eq '${key}' and deleted eq false`
        };
        return this.http.get(`${ApiUserSettingsConstants.URL}`, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    verifySACAPRegistration(constituentId) {
        return this.http.get(`${ApiRecipientVerificationConstants.URL}/${constituentId}`, {});
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: HttpClient }
    ];
};
RecipientService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RecipientService);
